import ApiService from '@/services/api.service'

const CustomExportsService = {
    getAll( parameter) { 
        const requestData = {
            method: 'get',
            url: "/CustomExports/",
            headers: {
            },
            params: parameter
        }     
        
        return ApiService.customRequest(requestData);         
    },

    get(id) {
        return ApiService.get(`/CustomExports/${encodeURIComponent(id)}`);
    },

    execute(parameters) {
        return ApiService.getWithArray("/CustomExports/execute", parameters);
    }
}

export default CustomExportsService;